import React, { Component } from 'react';
import {
  Link
} from 'react-router-dom';

import '../../helpers/Array'
import Content from '../../components/Content'
import Item from '../../components/Item'
import Icon from '../../components/Icon'
import Media from '../../components/Media'

import moment from 'moment';

class Twitter extends Component {

	constructor(props) {
    super(props);

  }





  render() {

     let type = this.props.type


     var divStyle = {
        backgroundImage: 'url(http://thefenway.archivestud.io/assets/feed-me.svg)',
    };

    switch(type) {

      case "small" :
        return (
          <Item modifiers={['sponsorSmall']}>
            <Link to="/promotions/bucket-of-beers">
              <div className="Item-container">

                <div className="Item-head">

                  <div className="Item-logo">
                      <Content>
                        <h5>Beer Works</h5>
                      </Content>
                  </div>

                  <div className="Item-title">

                    <Content modifier={'sponsor'}>
                        <h3>Bucket<br/> of beers<br/> $21.50</h3>
                    </Content>

                  </div>

                  <div className="Item-cta">
                    <Icon type={'arrow-right-white'} />
                  </div>


                </div>

                <div className="Item-body"></div>

                <div className="Item-foot"></div>

                <div className="Item-expireDate">
                  <Content><small>Exp. 12.23</small></Content>
                </div>

              </div>
            </Link>
          </Item>
        );
      break;

      case "tall" :

        return (
          <Item modifiers={['sponsorTall']}>
            <Link to="/news/2017/cozy-coffee">
              <div className="Item-container">

                <div className="Item-head">

                  <div className="Item-tag">

                    <Content modifier={'yellow'}>
                      <h4>Sponsored</h4>
                    </Content>

                  </div>

                  <div className="Item-title">

                    <Content modifier={'yellow'}>
                      <h1>dine like<br/>a king</h1>
                    </Content>

                  </div>

                </div>

                <div className="Item-body">

                  <div className="Item-media">
                    <div className="Image  Image--fluid">
                      <div className="Image-media" style={divStyle}></div>
                    </div>
                  </div>

                  <div className="Item-icon">
                     <Icon type={'arrow-right-black'} />
                  </div>


                </div>

              </div>


            </Link>
          </Item>
        );

      break;

      default :
        return null;
      break;

    }


  }
}

export default Twitter;



// WEBPACK FOOTER //
// ./src/js/components/LocationAd/LocationAd.js